import { render, staticRenderFns } from "./profile-edit.vue?vue&type=template&id=3767bf35&scoped=true&"
import script from "./profile-edit.vue?vue&type=script&lang=js&"
export * from "./profile-edit.vue?vue&type=script&lang=js&"
import style0 from "./profile-edit.vue?vue&type=style&index=0&id=3767bf35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3767bf35",
  null
  
)

export default component.exports